import { useEffect } from "react";
import { toast } from "sonner";
import { registerSW } from "virtual:pwa-register";

const TOAST_ID = "pwa-update";
const MIN_CHECK_INTERVAL_MS = 10 * 60 * 1000;

export function UpdatePrompt() {
  useEffect(() => {
    let registration: ServiceWorkerRegistration | undefined;
    let lastCheck = 0;

    const updateSW = registerSW({
      onRegisteredSW(_url, r) {
        registration = r;
      },
      onNeedRefresh() {
        toast("Update available", {
          id: TOAST_ID,
          duration: Infinity,
          action: {
            label: "Reload",
            onClick: () => updateSW(true),
          },
        });
      },
    });

    // Re-check for updates whenever the page becomes visible. Covers desktop
    // tab switching, window minimize/restore, and iOS standalone PWAs returning
    // from background (where there's no URL bar / pull-to-refresh affordance).
    // Throttled because rapid Cmd-Tab shouldn't hammer /sw.js.
    const onVisibilityChange = () => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastCheck < MIN_CHECK_INTERVAL_MS) return;
      lastCheck = Date.now();
      registration?.update();
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  return null;
}
